import { render } from "./PagamentoStatusBadge.vue?vue&type=template&id=cd72cf22"
import script from "./PagamentoStatusBadge.vue?vue&type=script&lang=js"
export * from "./PagamentoStatusBadge.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__